"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReactSetup = exports.EReactRouterProvider = exports.EReactStyleProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
var EReactStyleProvider;
(function (EReactStyleProvider) {
    EReactStyleProvider["FELA"] = "FELA";
})(EReactStyleProvider || (exports.EReactStyleProvider = EReactStyleProvider = {}));
var EReactRouterProvider;
(function (EReactRouterProvider) {
    EReactRouterProvider["REACT_ROUTER"] = "REACT_ROUTER";
})(EReactRouterProvider || (exports.EReactRouterProvider = EReactRouterProvider = {}));
function createReactTreeFunction({ server = false, useRouter, useStyleProvider, apolloProvider, strictMode = false, } = {}) {
    let RouterComponent = ({ children }) => children;
    let StyleProvider = ({ children }) => children;
    let ApolloProviderComponent = ({ children }) => children;
    if (useRouter != null) {
        if (useRouter === EReactRouterProvider.REACT_ROUTER) {
            if (!server) {
                RouterComponent = require("react-router-dom").Router;
            }
            else {
                RouterComponent = require("react-router-dom").StaticRouter;
            }
        }
    }
    if (useStyleProvider != null) {
        if (useStyleProvider === EReactStyleProvider.FELA) {
            StyleProvider = require("react-fela").RendererProvider;
        }
    }
    if (apolloProvider !== undefined) {
        ApolloProviderComponent = apolloProvider;
    }
    if (!server) {
        return (AppComponent, { apolloClient, routerProps, styleProviderProps } = {}) => apolloClient ? ((0, jsx_runtime_1.jsx)(ApolloProviderComponent, { client: apolloClient, children: (0, jsx_runtime_1.jsx)(StyleProvider, { ...styleProviderProps, children: (0, jsx_runtime_1.jsx)(RouterComponent, { ...routerProps, children: (0, jsx_runtime_1.jsx)(AppComponent, {}) }) }) })) : ((0, jsx_runtime_1.jsx)(StyleProvider, { ...styleProviderProps, children: (0, jsx_runtime_1.jsx)(RouterComponent, { ...routerProps, children: (0, jsx_runtime_1.jsx)(AppComponent, {}) }) }));
    }
    else {
        return (AppComponent, { apolloClient, styleProviderProps, routerProps } = {}) => apolloClient ? ((0, jsx_runtime_1.jsx)(ApolloProviderComponent, { client: apolloClient, children: (0, jsx_runtime_1.jsx)(StyleProvider, { ...styleProviderProps, children: (0, jsx_runtime_1.jsx)(RouterComponent, { ...routerProps, children: (0, jsx_runtime_1.jsx)(AppComponent, {}) }) }) })) : ((0, jsx_runtime_1.jsx)(StyleProvider, { ...styleProviderProps, children: (0, jsx_runtime_1.jsx)(RouterComponent, { ...routerProps, children: (0, jsx_runtime_1.jsx)(AppComponent, {}) }) }));
    }
}
exports.ReactSetup = {
    createReactTreeFunction,
};
